export const configMock = {
  faceQualityHostname: process.env.REACT_APP_DOMAIN_FACE_QUALITY,
  documentQualityHostname: process.env.REACT_APP_DOMAIN_DOCUMENT_QUALITY,
  sampleAppHostname: process.env.REACT_APP_DOMAIN_MIDDLEWARE,
  livenessPolicyName: process.env.REACT_APP_LIVENESS_POLICY_NAME,
  tenant: "",
  extraConfig: {
    firebase: {},
    sentry: {}
  }
}